import { Box, Grid, Link, Typography, useMediaQuery } from "@mui/material";
import { grey } from "@mui/material/colors";
import bentoLogo from "assets/logos/logo-transparent-dark-bg.png";
import profile from "assets/splashpage/profile.jpg";
import { ReactNode } from "react";

import {
  BRAND_LANDING_PAGE_LINK,
  LANDING_PAGE_LINK,
} from "constants/influencer";
import { trackEvent } from "utils/tracking";

import styles from "./styles";

interface LayoutProps {
  children: ReactNode;
  isBrand?: boolean;
}

const InfluencerLayout = ({ isBrand = false, children }: LayoutProps) => {
  const isMobileScreen = useMediaQuery("(max-width:980px)");

  const goToLandingPage = () => {
    trackEvent("Landing Page Logo Clicked", {
      "Clicked From": "Login/Signup Page",
    });
    window.open(isBrand ? BRAND_LANDING_PAGE_LINK : LANDING_PAGE_LINK, "_self");
  };

  if (isMobileScreen) {
    return (
      <Grid container sx={styles.mobilePage}>
        <Box sx={styles.mobileContent}>
          <Typography textAlign="center" sx={styles.mobileHeader}>
            Automate brand pitching with{" "}
            <Box component="span">
              <Link sx={styles.brandLink} onClick={goToLandingPage}>
                Bento
              </Link>
            </Box>
          </Typography>

          <Grid container gap={1} justifyContent="center" sx={{ mb: 2 }}>
            <Box sx={styles.mobileCard}>🤝 1M+ Brand Contacts</Box>
            <Box sx={styles.mobileCard}>🔔 Automated Follow-Ups</Box>
            <Box sx={styles.mobileCard}>✍️ Customized Pitch Templates</Box>
          </Grid>

          {children}
          <Typography textAlign="center" sx={styles.mobilePromo}>
            💥 <strong>Sign Up Today</strong> and get{" "}
            <Box component="span" sx={styles.mobilePromoOff}>
              25% off
            </Box>{" "}
            within your first month
          </Typography>
        </Box>
      </Grid>
    );
  }

  return (
    <Box sx={styles.page}>
      <Box sx={styles.brandPanel}>
        <Box sx={styles.orbYellow} />
        <Box sx={styles.orbPurple} />

        <Box sx={styles.brandContent}>
          <Box
            component="img"
            src={bentoLogo}
            alt="Bento"
            sx={styles.logo}
            onClick={goToLandingPage}
          />

          <Box sx={styles.brandMain}>
            <Typography sx={styles.header}>
              Put your brand pitching on{" "}
              <Box component="span" sx={styles.highlight}>
                autopilot
              </Box>{" "}
              with{" "}
              <Box component="span">
                <Link sx={styles.brandLinkPlain} onClick={goToLandingPage}>
                  Bento
                </Link>
              </Box>
            </Typography>

            <Box sx={styles.cardRow}>
              <Box sx={styles.card}>
                <Box
                  sx={[styles.littleCircle, { backgroundColor: "green.light" }]}
                />
                <Box sx={styles.cardStat}>1M+</Box> Brand Contacts Worldwide
              </Box>

              <Box sx={styles.card}>
                <Box
                  sx={[styles.littleCircle, { backgroundColor: "purple.main" }]}
                />
                <Box sx={styles.cardStat}>Automated</Box>
                Follow-Ups On Your Behalf
              </Box>

              <Box sx={styles.card}>
                <Box
                  sx={[styles.littleCircle, { backgroundColor: "yellow.main" }]}
                />
                <Box sx={styles.cardStat}>Customized</Box>
                Pitch Templates that Convert
              </Box>
            </Box>
          </Box>

          <Box sx={styles.glass}>
            <Box
              component="img"
              src={profile}
              alt=""
              sx={styles.testimonialAvatar}
            />
            <Box>
              <Typography sx={styles.testimonialQuote}>
                I get all my students started on bento - in fact the comment
                section here is FULL of their stories. I have{" "}
                <Box component="span" sx={styles.testimonialEarnings}>
                  students earning anywhere from $1000 - $4000
                </Box>{" "}
                within their first month of pitching all because of bento
              </Typography>
              <Typography sx={styles.testimonialName}>
                <strong>Sydney Mohni</strong>
              </Typography>
              <Typography sx={[styles.testimonialName, { color: grey[400] }]}>
                UGC Creator & Coach
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={styles.formPanel}>
        <Box sx={styles.formCard}>
          {children}
          <Typography sx={styles.text}>
            💥 <strong>Sign Up Today</strong> and get{" "}
            <Box component="span" sx={styles.promoOff}>
              25% off
            </Box>{" "}
            within your first month
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default InfluencerLayout;
